export default "__VITE_ASSET__C5X_UtdM__"